interface ClaimsTableSkeletonProps {
  rows: number;
  isMobile: boolean;
}

export function ClaimsTableSkeleton({ rows, isMobile }: ClaimsTableSkeletonProps) {
  if (isMobile) {
    return (
      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="rounded-lg border bg-card shadow-sm p-3 space-y-2 animate-pulse">
            <div className="flex justify-between">
              <div className="h-4 w-24 bg-muted rounded" />
              <div className="h-5 w-16 bg-muted rounded-full" />
            </div>
            <div className="space-y-1.5">
              <div className="h-3 w-32 bg-muted rounded" />
              <div className="h-3 w-48 bg-muted rounded" />
              <div className="h-3 w-20 bg-muted rounded" />
              <div className="h-3 w-24 bg-muted rounded" />
            </div>
            <div className="flex gap-1.5 pt-2 border-t">
              <div className="h-8 flex-1 bg-muted rounded" />
              <div className="h-8 flex-1 bg-muted rounded" />
              <div className="h-8 w-8 bg-muted rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <table className="w-full">
      <thead className="bg-muted">
        <tr>
          {["Claim #", "Insured", "Property", "Peril", "Status", "Date of Loss", "Est. Value", "Actions"].map(h => (
            <th key={h} className="text-left py-3 px-4 lg:px-6 text-sm font-medium text-muted-foreground">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-border">
        {Array.from({ length: rows }).map((_, i) => (
          <tr key={i} className="animate-pulse">
            <td className="py-3 px-4 lg:py-4 lg:px-6"><div className="h-4 w-20 bg-muted rounded" /></td>
            <td className="py-3 px-4 lg:py-4 lg:px-6"><div className="h-4 w-28 bg-muted rounded" /></td>
            <td className="py-3 px-4 lg:py-4 lg:px-6">
              <div className="space-y-1">
                <div className="h-4 w-36 bg-muted rounded" />
                <div className="h-3 w-24 bg-muted rounded" />
              </div>
            </td>
            <td className="py-3 px-4 lg:py-4 lg:px-6"><div className="h-4 w-16 bg-muted rounded" /></td>
            <td className="py-3 px-4 lg:py-4 lg:px-6"><div className="h-5 w-20 bg-muted rounded-full" /></td>
            <td className="py-3 px-4 lg:py-4 lg:px-6"><div className="h-4 w-20 bg-muted rounded" /></td>
            <td className="py-3 px-4 lg:py-4 lg:px-6"><div className="h-4 w-16 bg-muted rounded" /></td>
            <td className="py-3 px-4 lg:py-4 lg:px-6">
              <div className="flex space-x-1">
                {Array.from({ length: 5 }).map((_, j) => (
                  <div key={j} className="h-8 w-8 bg-muted rounded" />
                ))}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
